"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

// Libraries
var Window =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Window, _React$Component);

  function Window(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Window);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Window).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClick", function (event) {
      if (!_this.ref.current) {
        console.log('Missing ref to Window child. Make sure to set the `ref` prop on ' + 'a React component.');
        return;
      }

      var node = _reactDom["default"].findDOMNode(_this.ref.current);

      if (node.contains(event.target)) {
        // Click is inside, ignore.
        return;
      }

      _this.props.onOutsideClick(event);
    });
    _this.ref = _react["default"].createRef();
    return _this;
  }

  (0, _createClass2["default"])(Window, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mouseup', this.handleClick, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mouseup', this.handleClick, false);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children({
        ref: this.ref
      });
    }
  }]);
  return Window;
}(_react["default"].Component);

var _default = Window;
exports["default"] = _default;